import { RESOURCE_STATUS } from "../../../constants";

export const DELETED_STATUS_FILTER = { status: RESOURCE_STATUS.DELETED };
export const ACTIVE_STATUS_FILTER = { status: RESOURCE_STATUS.ACTIVE };
